export const EVENTS = [
    {
        id: "firmacopie-roma",
        title: 'Firmacopie a "Più libri più liberi"',
        when: "Lunedì 7 dicembre 2026, ore 17:00 – 18:00",
        where: 'Roma – La Nuvola, fiera "Più libri più liberi" (4–8 dicembre 2026)',
        text: "Il Dott. Giovanni De Lorenzo firmerà le copie di «Prima di pensare. Perché facciamo cose che non volevamo fare» (Armando Editore). Vieni a trovarlo per un saluto e una dedica.",
        image: null,
        imageAlt: "Locandina del firmacopie del Dott. Giovanni De Lorenzo alla fiera Più libri più liberi di Roma",
        ics: "/eventi/firmacopie-roma.ics",
        endsAt: "2026-12-08T00:00:00+01:00",
        photos: null,
        note: null,
    },
    {
        id: "presentazione-melfi",
        title: "Il valore del confronto",
        when: "8 ottobre 2026, Centro Nitti, Melfi",
        where: "Centro Nitti, Melfi",
        text: "Ci sono occasioni in cui un libro diventa qualcosa di più delle pagine che lo compongono. Diventa uno spazio di confronto, un modo per condividere domande e riflessioni che riguardano tutti noi.",
        image: null,
        endsAt: "2026-10-09T00:00:00+02:00",
        ics: null,
        note: "Presentazione di «Prima di pensare» — 8 ottobre 2026, Centro Nitti, Melfi",
        photos: [
            { src: "/images/evento-4.jpg", alt: "I relatori al tavolo durante la presentazione del libro al Centro Nitti di Melfi", pos: "object-center" },
            { src: "/images/evento-3.jpg", alt: "La sala gremita durante la presentazione di «Prima di pensare» a Melfi", pos: "object-center" },
            { src: "/images/evento-2.jpg", alt: "Il Dott. Giovanni De Lorenzo accanto al totem del libro Prima di pensare", pos: "object-top" },
            { src: "/images/evento-1.jpg", alt: "Il Dott. De Lorenzo consegna una copia del libro a una partecipante", pos: "object-center" },
        ],
    },
];

export const upcomingEvents = () => EVENTS.filter((e) => new Date(e.endsAt) > new Date());
export const pastEvents = () => EVENTS.filter((e) => new Date(e.endsAt) <= new Date());
